import { render, staticRenderFns } from "./CompanyProjectDetail.vue?vue&type=template&id=cdadf136&"
import script from "./CompanyProjectDetail.vue?vue&type=script&lang=js&"
export * from "./CompanyProjectDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cdadf136')) {
      api.createRecord('cdadf136', component.options)
    } else {
      api.reload('cdadf136', component.options)
    }
    module.hot.accept("./CompanyProjectDetail.vue?vue&type=template&id=cdadf136&", function () {
      api.rerender('cdadf136', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/job-request/components/CompanyProjectDetail.vue"
export default component.exports